// Transform "Add Logo" dropdown to checkbox and handle conditional upload visibility
(function() {
  console.log('[Angle3D Logo] Script loaded');

  function initLogoCheckbox() {
    // Find all customization options
    const allOptions = document.querySelectorAll('.tda-customizer-customization-option');

    // Find the "Add Logo" option
    const addLogoOption = Array.from(allOptions).find(option => {
      const title = option.querySelector('.tda-customizer-customization-option-title');
      return title && (
        title.textContent.toLowerCase().includes('add logo') ||
        title.textContent.toLowerCase().includes('logo visibility') ||
        title.textContent.toLowerCase() === 'logo'
      );
    });

    if (!addLogoOption) {
      setTimeout(initLogoCheckbox, 500);
      return;
    }

    // Find the value list containing the buttons
    const valueList = addLogoOption.querySelector('.tda-customizer-customization-option-value-list, .tda-customizer-select-button-customization-option-value-list');

    if (!valueList) {
      console.log('[Angle3D Logo] Value list not found');
      return;
    }

    console.log('[Angle3D Logo] Value list found:', valueList);

    // Find Yes/No buttons
    const buttons = valueList.querySelectorAll('button, .tda-customizer-customization-option-value, .tda-customizer-select-button-customization-option-value');
    let yesButton = null;
    let noButton = null;

    console.log('[Angle3D Logo] Found buttons:', buttons.length);

    buttons.forEach(btn => {
      const text = btn.textContent.trim().toLowerCase();
      console.log('[Angle3D Logo] Button text:', text);
      if (text.includes('yes')) yesButton = btn;
      if (text.includes('no')) noButton = btn;
    });

    if (!yesButton || !noButton) {
      console.log('[Angle3D Logo] Yes/No buttons not found. Yes:', yesButton, 'No:', noButton);
      return;
    }

    console.log('[Angle3D Logo] Yes button:', yesButton);
    console.log('[Angle3D Logo] No button:', noButton);

    // Hide the entire "Add Logo" option row by adding a CSS class
    addLogoOption.classList.add('tda-hide-add-logo-option');

    console.log('[Angle3D Logo] Add Logo option hidden with class:', addLogoOption.className);

    // Set up file upload monitoring - this will control the actual logo visibility
    monitorLogoUpload(yesButton, noButton);
  }

  function monitorLogoUpload(yesButton, noButton) {
    // Find the "Logo" upload option
    const uploadOption = Array.from(document.querySelectorAll('.tda-customizer-customization-option')).find(option => {
      const title = option.querySelector('.tda-customizer-customization-option-title');
      if (!title) return false;

      const titleText = title.textContent.toLowerCase().trim();
      return titleText === 'logo' || (
        titleText.includes('upload') &&
        (titleText.includes('logo') || titleText.includes('image'))
      );
    });

    if (!uploadOption) {
      console.log('[Angle3D Logo] Upload option not found for monitoring');
      return;
    }

    console.log('[Angle3D Logo] Monitoring logo upload field for file changes');

    // Find the file input within the upload option
    const fileInput = uploadOption.querySelector('input[type="file"]');

    if (fileInput) {
      console.log('[Angle3D Logo] File input found, setting up listeners');

      // Monitor file input changes
      fileInput.addEventListener('change', function() {
        console.log('[Angle3D Logo] File input changed, files:', this.files.length);

        if (this.files && this.files.length > 0) {
          // File uploaded - click Yes button to show logo on 3D model
          console.log('[Angle3D Logo] File uploaded, clicking Yes button');
          yesButton.click();
          console.log('[Angle3D Logo] Yes button clicked');
        } else {
          // File cleared - click No button to hide logo on 3D model
          console.log('[Angle3D Logo] File cleared, clicking No button');
          noButton.click();
          console.log('[Angle3D Logo] No button clicked');
        }
      });

      // Also check initial state
      if (fileInput.files && fileInput.files.length > 0) {
        console.log('[Angle3D Logo] Initial state: file already present, clicking Yes button');
        yesButton.click();
      }
    } else {
      console.log('[Angle3D Logo] File input not found, trying to observe DOM changes');

      // If file input not immediately available, observe for it
      const observer = new MutationObserver(() => {
        const newFileInput = uploadOption.querySelector('input[type="file"]');
        if (newFileInput) {
          console.log('[Angle3D Logo] File input appeared, setting up listeners');

          newFileInput.addEventListener('change', function() {
            console.log('[Angle3D Logo] File input changed (observer), files:', this.files.length);

            if (this.files && this.files.length > 0) {
              console.log('[Angle3D Logo] File uploaded, clicking Yes button');
              yesButton.click();
            } else {
              console.log('[Angle3D Logo] File cleared, clicking No button');
              noButton.click();
            }
          });

          observer.disconnect();
        }
      });

      observer.observe(uploadOption, { childList: true, subtree: true });
    }

    // Also monitor for any image previews or upload indicators and their removal
    let hasImage = false;
    const imageObserver = new MutationObserver(() => {
      const uploadedImage = uploadOption.querySelector('img[src*="blob:"], img[src*="data:image"], canvas, [class*="preview"], [class*="uploaded"]');

      if (uploadedImage && !hasImage) {
        console.log('[Angle3D Logo] Uploaded image detected in DOM');
        hasImage = true;
        yesButton.click();
      } else if (!uploadedImage && hasImage) {
        console.log('[Angle3D Logo] Image removed from DOM, clicking No button');
        hasImage = false;
        noButton.click();
      }
    });

    imageObserver.observe(uploadOption, { childList: true, subtree: true, attributes: true });

    // Also watch for remove/delete buttons in the upload option
    uploadOption.addEventListener('click', (e) => {
      const target = e.target;

      // Check if clicked element is a remove/delete button
      if (target.matches('button[class*="remove"], button[class*="delete"], button[class*="clear"], [class*="remove-"], [class*="delete-"], [class*="clear-"]') ||
          target.closest('button[class*="remove"], button[class*="delete"], button[class*="clear"]')) {

        console.log('[Angle3D Logo] Remove button clicked, waiting for image to be removed');

        // Wait a bit for the removal to process, then check if image is gone
        setTimeout(() => {
          const fileInput = uploadOption.querySelector('input[type="file"]');
          const uploadedImage = uploadOption.querySelector('img[src*="blob:"], img[src*="data:image"], canvas, [class*="preview"], [class*="uploaded"]');

          if ((!fileInput || !fileInput.files || fileInput.files.length === 0) && !uploadedImage) {
            console.log('[Angle3D Logo] Image confirmed removed, clicking No button');
            noButton.click();
          }
        }, 100);
      }
    });
  }

  // Initialize when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initLogoCheckbox);
  } else {
    // If DOM already loaded, wait a bit for Angle 3D to render
    setTimeout(initLogoCheckbox, 1000);
  }
})();
